import React, {useState} from "react"
import {useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import Tick from "../../../../../assets/images/sucess-big-tick.png"
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import "./account-created.scss"

export default function AccountCreated() {
    const [openOtp, setOpenOtp] = useState();
    const navigate = useNavigate()

    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors},
        control,
        clearErrors
    } = useForm({
        mode: 'onChange',
    })
    const onSubmit = async (data) => {
        console.log(data)
        navigate('/account-setup')
    }
    return(
        <div className={'login'}>
            <div className={'account-created'}>
                <img src={Tick} className={'img-fluid'}/>
                <h4>Account Created !</h4>
                <p>Aenean posuere eget nibh sit amet iaculis. Nulla tortor diam, sollicitudin at sodales sit amet</p>
                <div className={'dfields mt-4'}>
                    <ThemeButton
                        text={'Continue'}
                        className={'btn-light-lg'}
                        type={'submit'}
                        route={'/account-setup'}
                    />
                </div>
            </div>
        </div>
    )
}